import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: [
    '../../shared/Styles/public-page.css',
    './contact.component.css'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactComponent {
  public readonly reasonIds = [1, 2, 3];
}
